import { WeekDay, WeekDayNum } from "@/types/hotelService";

export function getDate(date: Date | string): string {
  const formatedDate = new Date(date);

  const dd = String(formatedDate.getUTCDate()).padStart(2, "0");
  const mm = String(formatedDate.getUTCMonth() + 1).padStart(2, "0"); // months 0-based
  const yyyy = formatedDate.getUTCFullYear();

  return `${dd}.${mm}.${yyyy}`;
}

export function getPercentageOf(percent: number, total: number) {
  return (percent / 100) * total;
}

export function transformWeekDaysToNumber(weekDays: WeekDay[]) {
  return weekDays.map((d) => WeekDayNum[d]);
}

export function getUnavailableDaysFromAvailable(weekDays: WeekDay[]) {
  return Object.values(WeekDay).filter((d) => !weekDays.includes(d));
}
